import {Typography} from "@mui/material";

const Text = ({value, style}) => {
  return (<Typography  style={style} >{value}</Typography>)
}
export default Text;